const removeMailDeleteHashId = () => {
  // removing deleteHashId from url
  const thisUrl = window.location.pathname;
  const newUrl = thisUrl.replace(/\/delete\/.*/, "");
  window.history.pushState({}, "", newUrl);
};

export default removeMailDeleteHashId;
